export default {
    methods: {
        utilityPosNeg(value, reversed=false) {
            let utilityClass = '';
            let percentageSign = '%';
            let intValue = parseFloat(value);

            if (intValue == 0 || value == 'N/A' || value == '-') {
                utilityClass = 'Utility__neutral';
            } else if ((intValue > 0 && ! reversed) || (intValue < 0  && reversed)) {
                utilityClass = 'Utility__positive';
            } else {
                utilityClass = 'Utility__negative';
            }

            if (value == 'N/A' || value == '-') {
                percentageSign = '';
            }

            return '<span class="' + utilityClass + '">' + value + percentageSign + '</span>';
        }
    }
}